import type { TFunction } from "i18next";
import type { TourStep } from "../TourProvider";
import { queryTourTarget } from "../utils/queryTourTarget";

/**
 * Tour configuration for Amenity Table (/amenity)
 */
export const amenityTableTour = (t: TFunction): TourStep[] => [
  {
    title: t("Tour_AmenityTable_Welcome_Title"),
    description: t("Tour_AmenityTable_Welcome_Description"),
    target: () => queryTourTarget("amenity-table-section"),
    placement: "bottom",
  },
  {
    title: t("Tour_AmenityTable_Add_Title"),
    description: t("Tour_AmenityTable_Add_Description"),
    target: () => queryTourTarget("amenity-add-button"),
    placement: "left",
  },
];
